import { html, LitElement, css, unsafeCSS } from 'lit';

import '../components/comments';
import '../parts/card';

import style from './changelog.scss';
import { processLog } from '../shared/parse';
import { DATA_CHANGELOG } from '../data/sources';
import { VERSION_OVERRIDE } from '../shared/types';
import { getNameFromURL, setTitle, trackPage } from '../shared/utils';

export class ChangelogPage extends LitElement {

    static get properties() {
        return {
        }
    }

    constructor() {
        super();        
        this.ver = '';     
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        this.ver = getNameFromURL();       
        setTitle('Changelog '+this.ver.replace(/\-/g,'.'));
    }    

    render() {                       
        let delcards = DATA_CHANGELOG[this.ver].filter(c=>c.log[0] === 'Card Removed');
        let newcards = DATA_CHANGELOG[this.ver].filter(c=>c.log[0] === 'Card Added' && c.rarity !== 4 && c.category !== 10);
        let newtalents = DATA_CHANGELOG[this.ver].filter(c=>c.log[0] === 'Card Added' && c.category === 10);
        let monstercards = DATA_CHANGELOG[this.ver].filter(c=>c.log[0] === 'Card Added' && c.rarity === 4 && c.category !== 10);
        let updates = DATA_CHANGELOG[this.ver].filter(c=>c.log[0] !== 'Card Added' && c.log[0] !== 'Card Removed');
        return html`
            <h1>Changelog ${(VERSION_OVERRIDE[this.ver]?VERSION_OVERRIDE[this.ver]:this.ver).replace(/\-/g,'.')}</h1>            
            ${newcards.length > 0 ? html`
            <h3>New Cards (${newcards.length})</h3>
            ${newcards.map(card=>{
                return html`
                    <div style="margin: 12px 0;">
                        <card-part id="${card.id}"></card-part>
                    </div>                    
                `;
            })}
            `:''}           
            ${newtalents.length > 0 ? html`
            <h3>New Talents (${newtalents.length})</h3>
            ${newtalents.map(card=>{
                return html`
                    <div style="margin: 12px 0;">
                        <card-part id="${card.id}" talent="true"></card-part>
                    </div>                    
                `;
            })}
            `:''}        
            ${updates.length > 0 ? html`   
            <h3>Updates (${updates.length})</h3>         
            ${updates.map(card=>{
                return html`
                    <card-part id="${card.id}" talent="${card.category===10}"></card-part>
                    <ul>
                        ${card.log.map(l=>{
                            return processLog(l);
                        })}
                    </ul>
                `;
            })}
            `:''}
            ${monstercards.length > 0 ? html`
            <h3>New Monster Cards (${monstercards.length})</h3>
            ${monstercards.map(card=>{
                return html`
                    <div style="margin: 12px 0;">
                        <card-part id="${card.id}"></card-part>
                    </div>                    
                `;
            })}
            `:''}
            ${delcards.length > 0 ? html`
            <h3>Removed (${delcards.length})</h3>
            ${delcards.map(card=>{
                return html`
                    <div style="margin: 12px 0;">
                        <card-part id="${card.id}"></card-part>
                    </div>                    
                `;
            })}
            `:''}
            <h3>Changelogs</h3>  
            ${Object.keys(DATA_CHANGELOG).map((ver,i) => {   
                if(DATA_CHANGELOG[ver].length === 0)
                    return '';             
                return html`
                        <div class="bubble big">
                            <a href="./changelog/${ver}"><div class="world-name">${(VERSION_OVERRIDE[ver] ? VERSION_OVERRIDE[ver] : ver).replace(/\-/g, '.')}</div></a>
                        </div>
                    `;
            })
            }
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('changelog-page', ChangelogPage);